import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const FormStateSlice = createSlice({
  name: "formState",
  initialState: "",
  reducers: {
    updateFormState: (state, action: PayloadAction<string>) => {
      void state;
      return action.payload;
    },
  },
});

export const { updateFormState } = FormStateSlice.actions;
export default FormStateSlice.reducer;
